"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enLocaleData = require("i18next-icu/locale-data/en");
exports.default = enLocaleData;
//# sourceMappingURL=en.js.map